// NOTE: FAB 사용성관련(필터모드 사용여부)
import push from '@/utils/gaEvents/push'

const onClickFilterButton = () => {
  push({
    //NOTE: fab_클릭_판매onoff -> filter_click_구매가능
    //웹앱을 통한 판매가능여부 UI개선에 따른 사전 테스트를 위해 '구매가능' 버튼 클릭시에만 'filter_click_구매가능' 이벤트를 발생시키도록 함
    event: 'filter_click_구매가능',
    page: '지도화면'
  } satisfies GtagFABEvent)
}

const fabEvent = { onClickFilterButton }

export default fabEvent
